import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import NavBar from "../../components/NavBar";
import Footer from "../../components/landing/Footer";
import MainCareersSection from "../../components/careers/MainCareersSection";

const Careers = () => {
  useEffect(() => {
    document.title = "Majura - Join Our Team";
  }, []);

  return (
    <div style={{ width: "100vw", height: "100%" }}>
      <Grid container spacing={0} style={{ width: "100%", height: "100%" }}>
        <Grid size={{ xs: 12 }}>
          <NavBar isMain={false} isSticky={true} bgColor={'white'} />

          <main>
            <Stack
              direction={"column"}
              spacing={"50px"}
              style={{ width: "100%" }}
            >
              <MainCareersSection />
            </Stack>
          </main>

          <footer>
            <Footer />
          </footer>
        </Grid>
      </Grid>
    </div>
  );
};

export default Careers;
